import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import { BaseComponent } from '../../base/base.component';

import { WizardService } from '../../../services/wizard/wizard.service';
import { EventService } from '../../../services/event/event.service';

import { UtilsService } from 'common-lib/services';

import moment_ from 'moment';
const moment = moment_;
declare var $: any;
@Component({
    selector: 'wizard-specific-date-picker',
    templateUrl: './specific-date-picker.component.html',
    styleUrls: ['./specific-date-picker.component.scss', '../../form-styles.scss']
})
export class SpecificDatePickerComponent extends BaseComponent implements OnInit {
    @ViewChild('date', { static: true }) dateEl: ElementRef;
    @ViewChild('time', { static: true }) timeEl: ElementRef;
    private timeIntervals: { value: string; name: string }[] = [];
    private intervalLength = 15;
    private timeStart = moment('09:00', 'HH:mm');
    public datePickerLabel: 'Schedule' | 'Meeting should occur' = 'Meeting should occur';
    public dateStart = moment().format(); // for UI purposes we use dateStart: string but it is a moment object in Wizard
    public isLoading = false;
    public isActive = false;
    public isGroupClass = false;
    public dateFormat = 'MMM d';

    constructor(
        private wizardService: WizardService,
        private eventService: EventService,
        @Inject(UtilsService) private utilsService: UtilsService
    ) {
        super();
    }

    ngOnInit() {
        this.dateFormat = window.innerWidth > 350 ? 'mediumDate' : 'MMM d';
        this.timeIntervals = this.utilsService.createSemanticTimeIntervals(this.intervalLength);
        this.initDefaultValues();
        if (this.data.mode === 'group-class') this.initGroupClassUI();
        this.initSemantic();
    }

    private initDefaultValues() {
        this.timeStart = this.wizardService.options.timeStart || moment('09:00', 'HH:mm').add(1, 'days');
        this.dateStart = this.wizardService.options.dateStart?.format() || moment().add(1, 'days').format();
        this.wizardService.updateOptions({
            dateStart: moment(this.dateStart),
            timeStart: this.timeStart,
            bookAnyhow: false
        });
    }

    private initSemantic() {
        $(this.dateEl.nativeElement).calendar({
            type: 'date',
            minDate: new Date(),
            formatInput: false,
            on: 'click',
            onChange: (date: string) => {
                if (!date) return;
                const dateStart = moment(date);
                this.dateStart = dateStart.format();
                this.wizardService.updateOptions({ dateStart, bookAnyhow: false });
                this.eventService.clearErrorMessage('availability');
            }
        });

        /** this fires on init so timeStart is saved in Wizard memory */
        $(this.timeEl.nativeElement).dropdown({
            values: this.formatTimesWithDefaultValue(this.timeIntervals, this.timeStart.format('HH:mm')),
            onChange: (time: string) => {
                if (time) {
                    const timeStart = moment(time, 'HH:mm');
                    this.wizardService.updateOptions({ timeStart, bookAnyhow: false });
                    this.eventService.clearErrorMessage('availability');
                }
            }
        });
    }

    private initGroupClassUI() {
        this.isGroupClass = true;
        this.datePickerLabel = 'Schedule';
        /** Normally this is set in datePickerComponent but the group class does not use that */
        this.wizardService.updateOptions({ isSpecificTime: true });
    }

    private formatTimesWithDefaultValue(calculatedTimes: { name: string; value: string }[], defaultValue: string) {
        return calculatedTimes.map((time) => {
            return {
                ...time,
                selected: time.value === defaultValue
            };
        });
    }
}
